import { generateFullPath } from "../utils/fileHelpers";

const fetchMediaRest = async (config) => {
  const api = generateFullPath("/api/media/rest");

  return await fetch(api, config)
    .then((response) => response.json())
    .then((data) => data);
};

const getImages = async () => {
  const token = process.env.VUE_APP_MEDIA_TOKEN;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return await fetchMediaRest(config);
};

export default getImages;
